import axios from 'axios';
import { getBaseUrl } from './BaseURL';

const api = axios.create({
    baseURL: getBaseUrl(),
    timeout: 60000,
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
    },
});

export default api;
